import { render, staticRenderFns } from "./PptxWidgetPopup.vue?vue&type=template&id=57e111b1&scoped=true&"
import script from "./PptxWidgetPopup.vue?vue&type=script&lang=js&"
export * from "./PptxWidgetPopup.vue?vue&type=script&lang=js&"
import style0 from "./PptxWidgetPopup.vue?vue&type=style&index=0&id=57e111b1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e111b1",
  null
  
)

export default component.exports